import { render, staticRenderFns } from "./relatedValues.vue?vue&type=template&id=a333756e&scoped=true"
import script from "./relatedValues.vue?vue&type=script&lang=js"
export * from "./relatedValues.vue?vue&type=script&lang=js"
import style0 from "./relatedValues.vue?vue&type=style&index=0&id=a333756e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a333756e",
  null
  
)

export default component.exports